<template>
    <section v-if="rootCategories.length > 0" class="border-t pt-4 mt-8 w-full overflow-hidden">
        <div class="flex items-center justify-between gap-4 mb-4">
            <h3 class="text-xl font-semibold capitalize">{{ $t('label.browse_categories') }}</h3>
            <router-link :to="{ name: 'frontend.categories' }" class="text-sm font-medium text-primary hover:underline">
                {{ $t('label.categories') }}
            </router-link>
        </div>

        <Swiper dir="ltr" :speed="700" :loop="false" :navigation="true" :modules="modules" class="w-full" :breakpoints="breakpoints">
            <SwiperSlide v-for="category in rootCategories" :key="category.id" class="h-auto">
                <router-link :to="{ name: 'frontend.categories.children', params: { slug: category.slug } }"
                    class="w-full rounded-2xl border group overflow-hidden block">
                    <img class="w-full h-24 object-cover" :src="category.thumb" :alt="category.name" >
                    <span class="text-sm font-medium capitalize text-center py-2 px-3 overflow-hidden whitespace-nowrap text-ellipsis block group-hover:text-primary">
                        {{ category.name }}
                    </span>
                </router-link>
            </SwiperSlide>
        </Swiper>
    </section>
</template>

<script>
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import statusEnum from "../../../enums/modules/statusEnum";

export default {
    name: "ProductCategoryPrefooterComponent",
    components: {
        Swiper,
        SwiperSlide
    },
    setup() {
        return {
            modules: [Navigation, Pagination, Autoplay],
        }
    },
    data() {
        return {
            categories: [],
            breakpoints: {
                0: { slidesPerView: 2, spaceBetween: 12 },
                640: { slidesPerView: 3, spaceBetween: 16 },
                768: { slidesPerView: 4, spaceBetween: 16 },
                1024: { slidesPerView: 5, spaceBetween: 20 }
            },
        }
    },
    computed: {
        rootCategories: function () {
            return this.categories.filter((category) => !category.parent_id);
        }
    },
    mounted() {
        this.$store.dispatch("frontendProductCategory/lists", {
            paginate: 0,
            order_column: "id",
            order_type: "asc",
            parent_id: null,
            status: statusEnum.ACTIVE,
        }).then((res) => {
            this.categories = res.data.data || [];
        }).catch(() => {
        });
    }
}
</script>
